import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class AboutHome extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            
            loading : 1,
            content:this.props.content, 
        }
        

    }

    componentDidMount()
    {  
         
        if(this.props.content && this.state.loading === 1)
        {
             this.setState({loading:0}); 

              
        }
        
        
    }


    render()
    { 
        const categories = JSON.parse(localStorage.getItem("categories"));
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
          
    return (
        <div> 

            {categories.map((item, index) => (
  
        <Link className={index == 0 ? "service-card special" :  "service-card" } data-v-4028cc74="" to={base_url+`service-category/`+item.slug}>
        
         <div class="service-wrapper" data-aos="fade-left-right" data-aos-duration="1000" data-v-4028cc74="">
          <h1 class="service-content-headline" data-v-4028cc74="">
           {item.title}
          </h1>
          <p class="service-content-text" data-v-4028cc74="">
           <div dangerouslySetInnerHTML={{ __html: item.short_info }} />  
          </p>
          <div class="service-content-link" data-v-4028cc74="">
           READ MORE
          </div>
         </div> 
         <div class="service-image" data-aos="fade-up" data-aos-anchor-placement="center-bottom" data-aos-duration="1000" data-v-4028cc74="">
          <img alt={item.title} data-v-4028cc74="" loading="lazy" src={item.home_image} />
         </div>
        </Link>
            ))}
         
         
    

       </div>

    );
}

}

export default AboutHome;